import { DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Input, Row, Space, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";

const BidInformation = () => {
  const [form] = Form.useForm();
  const dataSource = [
    {
      key: "1",
      productName: "Computer",
      HSN: 324,
      variant: "Lenovo",
      requiredQty: 5,
    },
  ];

  const columns: ColumnsType<any> = [
    {
      title: "HSN",
      dataIndex: "HSN",
      key: "HSN",
      width: "10%",
    },
    {
      title: "Product Name",
      dataIndex: "productName",
      key: "productName",
    },
    {
      title: "Specifications / Variant",
      dataIndex: "variant",
      key: "variant",
    },
    {
      title: "Required Qty",
      dataIndex: "requiredQty",
      key: "requiredQty",
    },

    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",

      render: () => (
        <>
          <Space>
            <Button
              style={{ padding: "1px 5px" }}
              // onClick={() => setIsModelOpen(true)}
              size="small"
            >
              <EyeOutlined />
            </Button>
            <Button
              style={{ padding: "1px 5px" }}
              // onClick={() => setIsModelOpen(true)}
              size="small"
            >
              <DeleteOutlined />
            </Button>
          </Space>
        </>
      ),
    },
  ];
  return (
    <div>
      <Card size="small">
        <Form form={form}>
          <Form.Item>
            <Input
              addonBefore={
                <span
                  style={{
                    display: "inline-block",
                    width: "150px",
                    textAlign: "left",
                  }}
                >
                  Bid Name
                </span>
              }
            />
          </Form.Item>

          <Card size="small" style={{ marginBottom: "80px" }}>
            <Table
              columns={columns}
              dataSource={dataSource}
              size="middle"
              style={{ marginTop: "10px" }}
              pagination={false}
            />
          </Card>

          <Card
            title="Fulfilled Information"
            style={{ width: "100%", margin: "20px 0px" }}
            type="inner"
          >
            <Row gutter={20}>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item>
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Fulfilled By Date
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item>
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Fulfillment Location
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item style={{ marginBottom: "5px" }}>
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Required Documents
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item style={{ marginBottom: "5px" }}>
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Terms & Conditions
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
          <Card
            size="default"
            title="Bid Information"
            style={{ width: "100%", margin: "15px 0px" }}
            type="inner"
          >
            <Row gutter={20}>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item>
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Bid For
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item>
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Start Date & Time
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item style={{ marginBottom: "5px" }}>
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Required Documents
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
              <Col sm={12} xs={24} lg={12} xl={12}>
                <Form.Item style={{ marginBottom: "5px" }}>
                  <Input
                    addonBefore={
                      <span
                        style={{
                          display: "inline-block",
                          width: "150px",
                          textAlign: "left",
                        }}
                      >
                        Comment
                      </span>
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Form>
      </Card>
    </div>
  );
};

export default BidInformation;
